
import { campaignMixin } from "~/mixins";

export default {
  mixins: [campaignMixin],

  props: {
    selectedVariant: { type: Object, default: () => {} },
  },

  computed: {
    price() {
      return this.selectedVariant?.price;
    },
    compareAtPrice() {
      return this.selectedVariant?.compareAtPrice;
    },
  },
};
